"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _alloyReactIcon = require("@adsk/alloy-react-icon");

var _mediaDetailContext = require("../media-detail-context");

var _photoContext = require("../photo-context");

var _alloyReactTheme = _interopRequireDefault(require("@adsk/alloy-react-theme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const NavButtonContainer = _styledComponents.default.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 110px;
`;
const StyledPlusIcon = (0, _styledComponents.default)(_alloyReactIcon.PlusIcon)`
  cursor: pointer;
  &:hover {
    color: ${_alloyReactTheme.default.colors.adskBlue500};
  }
`;
const StyledMinusIcon = (0, _styledComponents.default)(_alloyReactIcon.MinusIcon)`
  cursor: pointer;
  &:hover {
    color: ${_alloyReactTheme.default.colors.adskBlue500};
  }
`;
const PhotoZoom = _styledComponents.default.div`
  font-size: ${_alloyReactTheme.default.typography.bodyMedium};
  cursor: pointer;
  &:hover {
    color: ${_alloyReactTheme.default.colors.adskBlue500};
  }
`;

const Zoom = () => {
  const {
    state: photoState,
    handlers: photoHandlers
  } = (0, _photoContext.usePhoto)();
  const {
    mediaHandlers
  } = (0, _mediaDetailContext.useMedia)();
  const zoomIn = (0, _react.useCallback)(() => {
    photoHandlers.setZoom(photoState.zoom + _photoContext.ZOOM_INCREMENT);
    mediaHandlers.zoomHandler && mediaHandlers.zoomHandler();
  }, [photoState, photoHandlers, mediaHandlers]);
  const zoomOut = (0, _react.useCallback)(() => {
    photoHandlers.setZoom(photoState.zoom - _photoContext.ZOOM_INCREMENT);
    mediaHandlers.zoomHandler && mediaHandlers.zoomHandler();
  }, [photoState, photoHandlers, mediaHandlers]);
  const fitToView = (0, _react.useCallback)(() => photoHandlers.setZoom(photoState.minZoom), [photoState, photoHandlers]);
  return /*#__PURE__*/_react.default.createElement(NavButtonContainer, null, /*#__PURE__*/_react.default.createElement(StyledMinusIcon, {
    size: 20,
    color: _alloyReactTheme.default.colors.white,
    onClick: zoomOut
  }), /*#__PURE__*/_react.default.createElement(PhotoZoom, {
    onClick: fitToView
  }, Math.round(photoState.zoom * 100), "%"), /*#__PURE__*/_react.default.createElement(StyledPlusIcon, {
    size: 20,
    color: _alloyReactTheme.default.colors.white,
    onClick: zoomIn
  }));
};

var _default = Zoom;
exports.default = _default;